// extracted by mini-css-extract-plugin
export default {"userAdElements":"AdminAdElements_userAdElements__NsLnE"};